{
	"recoveryPassword": "Récupération du mot de passe"
}
